import { SourceRange } from '../issues/Issue'
import { DocumentView } from './DocumentView'
import { NoDocumentView } from './NoDocumentView'
import { useActiveDocument } from './useActiveDocument'

export function ActiveDocumentView({
  textSelection,
  mode
}: {
  textSelection?: SourceRange
  mode: 'code' | 'inspector'
}) {
  const activeDocument = useActiveDocument()
  if (activeDocument) {
    return <DocumentView document={activeDocument} textSelection={textSelection} mode={mode} />
  } else {
    return <NoDocumentView />
  }
}
